import React from 'react';
import Menu from './Menu';

const MenuPage = () => {
  return (
    <div style={{paddingTop: '120px'}}>
      <Menu />
    </div>
  );
};

export default MenuPage;